import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { locksApi } from '@/shared/redux/api/assets/locks/locks-api';
import { projectsApi } from '@/shared/redux/api/assets/projects/projects-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';
import { AssetTypeEnum } from '@/shared/types/types.generated';

export const useInvalidateProjectTags = () => {
  const dispatch = useAppDispatch();

  const invalidateProjectTags = (
    projectId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          projectsApi.util.invalidateTags([
            { type: 'Project', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          projectsApi.util.invalidateTags([
            { type: 'Project', id: projectId },
            { type: 'Project', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetLocked:
      case TAssetOperationTypeEnum.AssetUnlocked:
        dispatch(
          locksApi.util.invalidateTags([
            { type: 'Lock', id: `${AssetTypeEnum.Project}:${projectId}` },
          ]),
        );
        break;
    }
  };

  const invalidateProjectVersionTags = (
    projectId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          projectsApi.util.invalidateTags([
            { type: 'Project', id: 'LIST' },
            { type: 'Project', id: projectId },
            { type: 'ProjectVersions', id: projectId },
            'Groups' as const,
          ]),
        );
        break;
      default:
        dispatch(
          projectsApi.util.invalidateTags([
            { type: 'Project', id: 'LIST' },
            { type: 'Project', id: projectId },
            { type: 'ProjectVersions', id: projectId },
          ]),
        );
        break;
    }
  };

  return {
    invalidateProjectTags,
    invalidateProjectVersionTags,
  };
};
